import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQ.css';

function FAQ() {
  const [activeCategory, setActiveCategory] = useState('security');

  const faqData = {
    security: [
      {
        q: "What is the 'Danger Zone'?",
        a: "The Danger Zone is a high-security section in your dashboard used for irreversible account actions. This includes permanently suspending your public profile and flushing all external platform statistics from DevTracker arrays via the Origin Core purge protocol."
      },
      {
        q: "How do I request an Account Purge?",
        a: "An Account Purge follows a 4-step audit process. Navigate to the Danger Zone in your Dashboard, initiate the 'Account Purge Audit', verify your identity by typing 'PURGE', and submit the final request to our Origin Core administrators for manual review."
      },
      {
        q: "What happens after an Account Purge?",
        a: "Upon approval, all your footprints (GitHub syncs, LeetCode stats, Codeforces history) are scrubbed from our database. Your Profile ID and SUID are de-indexed, and data recovery is impossible per our Zero-Knowledge retention policy."
      }
    ],
    identity: [
      {
        q: "Can I change my Public Profile ID?",
        a: "Profile IDs are permanent by default to maintain link integrity across the developer ecosystem. However, verified developers can initiate a managed 'ID Change Workflow'. This process involves 4-5 administrative checkstages to ensure data re-mapping is successful."
      },
      {
        q: "What is the ID Change Policy?",
        a: "Users must be in 'Active' standing for at least 30 days and have zero security flags. Changing your ID will break existing embed widgets and public links, requiring a manual update on your end as we do not maintain legacy redirects."
      }
    ],
    intelligence: [
      {
        q: "How often does my Neural DNA sync?",
        a: "The DAIV-2000 engine performs a primary handshake every 24 hours. However, you can trigger a manual 'Neural Refresh' from the Platform tab once every 6 hours if your third-party activity (e.g., LeetCode solves) requires immediate synchronization."
      },
      {
        q: "Is the DevTracker AI Bot E2E Encrypted?",
        a: "Yes. All conversations with the DevTracker Assistant utilize the DTAI-E2EE protocol. Messages are encrypted locally on your device before transmission, ensuring that only you and the Origin Core (for triage) can read the contents."
      },
      {
        q: "What is the accuracy of Career Forecasting?",
        a: "Our projections are based on linear regression of historical developer data. While highly accurate for market value estimation, they should be viewed as technical trajectories rather than absolute financial guarantees."
      }
    ],
    support: [
      {
        q: "My account is restricted. How do I appeal?",
        a: "If your login is blocked due to an 'Account Restricted' error, you must submit a formal appeal via the Neural Support form. Ensure you include your PRIVATE SUPPORT (SUID) in the appeal so our security board can uniquely identify your case."
      },
      {
        q: "Where do I find my SUID?",
        a: "Your SUID (Private Support Identifier) is located in the 'Security & ID' tab of your Dashboard. This identifier is your primary key for support communications when your account is inaccessible or restricted."
      }
    ]
  };

  return (
    <div className="faq-page page-container animate-up">
      <div className="container">
        <header className="faq-header">
          <span className="faq-tag">PLATFORM DOCUMENTATION</span>
          <h1>Frequently Asked Questions</h1>
          <p className="subtitle">Official guide to platform security, identity lifecycle, and account procedures.</p>
        </header>

        <div className="faq-layout">
          <aside className="faq-sidebar">
            <button className={`category-btn ${activeCategory === 'security' ? 'active' : ''}`} onClick={() => setActiveCategory('security')}>
              <i className="fa-solid fa-shield-halved"></i> Security & Purge
            </button>
            <button className={`category-btn ${activeCategory === 'identity' ? 'active' : ''}`} onClick={() => setActiveCategory('identity')}>
              <i className="fa-solid fa-id-card"></i> Identity & ID Changes
            </button>
            <button className={`category-btn ${activeCategory === 'intelligence' ? 'active' : ''}`} onClick={() => setActiveCategory('intelligence')}>
              <i className="fa-solid fa-brain"></i> Neural Integration
            </button>
            <button className={`category-btn ${activeCategory === 'support' ? 'active' : ''}`} onClick={() => setActiveCategory('support')}>
              <i className="fa-solid fa-headset"></i> Support & Appeals
            </button>
            
            <div className="faq-support-card glass-card">
              <h4>Still need help?</h4>
              <p>Our security board is available for complex case reviews.</p>
              <Link to="/contact" className="btn btn-primary">Contact Support</Link>
            </div>
          </aside>

          <main className="faq-content">
            <div className="faq-list">
              {faqData[activeCategory].map((item, index) => (
                <div key={index} className="faq-item glass-card animate-up" style={{animationDelay: `${index * 0.1}s`}}>
                  <div className="faq-question">
                    <i className="fa-solid fa-circle-question"></i>
                    <h3>{item.q}</h3>
                  </div>
                  <div className="faq-answer">
                    <p>{item.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>

      {/* Background Accents */}
      <div className="faq-blob blob-1"></div>
      <div className="faq-blob blob-2"></div>
    </div>
  );
}

export default FAQ;
